
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    customMessage = '';

    get4xxMessage(status: number ) {
        let message = '';
        switch (status) {
            case 400:
                message = '400 Bad Request';
                break;
            case 401:
                message = '401 Unauthorized';
                break;
            case 403:
                message = '403 Forbidden';
                break;
            case 404:
                message = '404 Not Found';
                break;
            case 408:
                message = '408 Request Timeout';
                break;
            case 410:
                message = '410 Gone';
                break;
            case 415:
                message = '415 Unsupported Media Type';
                break;
            case 441:
                message = '441 Unauthorized';
                break;
            default: // unknown client error
                message = 'Unknown Client Error';
                break;
        }
        return message;
    }

    setCustomMessage(message: string) {
        this.customMessage = message;
    }

    getCustomMessage(): string {
        return this.customMessage;
    }
}